import React, { Component } from 'react';
import { connect } from 'react-redux';


class Order extends Component {
    render() {
        return (
            <div style={{height: '100vh'}}>
                
                <div className="ui segment" style={{boxShadow: '0 0 5px 5px #00000020', margin: '2em'}}>
                <img class="image" style={{width: window.innerWidth < 600 ? '100%' : '35%', margin: '1em auto'}} src={this.props.photos[0]}></img>
                <form method="POST" className="ui form" action="/create" style={{ position: 'relative', top: '-40px', textAlign: 'left'}}>
                            <input id="img-val" type="text" name="image" placeholder="image url" style={{ visibility: 'hidden' }}/>
                            <div id="size-quantity">
                                <div className="two fields">
                                <div className="field">
                                    <label>Size</label>
                                        <select name="size" className="ui fluid dropdown">
                                        <option value="XXS">XXS</option> 
                                        <option value="XS">XS</option> 
                                        <option value="S">S</option> 
                                        <option value="M">M</option> 
                                        <option value="L">L</option>
                                        <option value="XL">XL</option> 
                                        <option value="XXL">XXL</option>  
                                        </select>                           
                                </div>
                                <div className="field">
                                    <label>Quantity</label>
                                    <input placeholder="Quantity" name="quantity" type="number"/>
                                </div>
                                </div>
                            </div>
                            <div className="field" style={{marginTop: '10px'}}>
                                <label>Address</label>
                                <div className="fields">
                                <div className="twelve wide field">
                                    <textarea id="address" name="address" placeholder="Street Address"></textarea>
                                </div>
                                </div>
                            </div>
                            
                            <div className="fields">
                                <div className="seven wide field">
                                <label>Card Number</label>
                                <input type="text" name="card[number]" maxlength="16" placeholder="Card #"/>
                                </div>
                                <div className="three wide field">
                                <label>CVC</label>
                                <input type="text" name="card[cvc]" maxlength="3" placeholder="CVC"/>
                                </div>
                                <div className="six wide field">
                                <label>Expiration</label>
                                <div className="two fields">
                                    <div className="field">
                                    <select className="ui fluid search dropdown" name="card[expire-month]">
                                        <option value="">Month</option>
                                        <option value="1">January</option>
                                        <option value="2">February</option>
                                        <option value="3">March</option>
                                        <option value="4">April</option>
                                        <option value="5">May</option>
                                        <option value="6">June</option>
                                        <option value="7">July</option>
                                        <option value="8">August</option>
                                        <option value="9">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                    </div>
                                    <div className="field">
                                    <input type="text" name="card[expire-year]" maxlength="4" placeholder="Year"/>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <button className="button-landing ui button right black disabled" style={{width: '100%'}} type="submit">Place Order</button>
                        </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({canvasImage, photos}) => {
    return {
        canvasImage,
        photos
    };
};

export default connect(mapStateToProps, null)(Order);